/**
 * Maps a click on a rendered node to an Ardoq shell action. The GraphView node id
 * is the component id, so a click opens that component in the inspector.
 */
import { dispatchAction } from '@ardoq/rxbeach';
import { selectComponent } from 'streams/components/ComponentActions';

export const inspectComponent = (componentId: string): void => {
  dispatchAction(selectComponent({ cid: componentId }));
};
